// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__246ZI","marketplaceStroke":"IconEmailAttention_marketplaceStroke__UnsP-","attentionStroke":"IconEmailAttention_attentionStroke__3zXC3"};